export const translations = {
  fr: {
    nav: { home: "Accueil", services: "Expertises", about: "Cabinet", contact: "Contact", book: "Prendre RDV" },
    hero: {
      eyebrow: "Conseil financier aux dirigeants",
      titleLines: ["Une fonction finance", "qui éclaire, sécurise"],
      titleAccent: "et accélère la performance.",
      lead: "EMG Performance 360 intervient lorsque la direction a besoin de visibilité, de maîtrise et d'une capacité d'exécution immédiate.",
      cta: "Échanger sur vos enjeux",
      ctaSecondary: "Nos domaines d'intervention",
    },
    pillars: {
      eyebrow: "Ce que nous apportons",
      items: [
        { num: "01", title: "Visibilité", body: "Une information fiable, lisible et orientée décision." },
        { num: "02", title: "Maîtrise", body: "Trésorerie, marges, coûts et risques sous contrôle." },
        { num: "03", title: "Exécution", body: "Des priorités traduites rapidement en actions mesurables." },
      ],
    },
    marquee: ["Décider", "Sécuriser", "Optimiser", "Transformer", "Visibilité", "Maîtrise", "Exécution"],
    intro: {
      eyebrow: "01 — Le cabinet",
      title: "Le conseil financier, au plus près de vos décisions.",
      body: "Cabinet spécialisé en direction financière, contrôle de gestion et pilotage de la performance, EMG Performance 360 structure la fonction finance, sécurise l'activité et transforme la donnée en leviers de décision — de l'enjeu ciblé à la prise en charge complète.",
      stats: [
        { value: "9", label: "Ans d'expérience" },
        { value: "200 M€", label: "Périmètre budgétaire piloté" },
        { value: "CODIR & COMEX", label: "Gouvernance" },
      ],
    },
    servicesPreview: {
      eyebrow: "02 — Domaines d'intervention",
      title: "Six expertises pour structurer, piloter et transformer la fonction finance.",
      cta: "Découvrir les expertises",
    },
    services: [
      {
        num: "01",
        title: "Direction financière externalisée",
        short: "Piloter la fonction finance, au rythme de l'entreprise.",
        desc: "Une direction financière disponible et opérationnelle, pour structurer, superviser et sécuriser l'ensemble de la fonction finance.",
        points: [
          "Structuration et pilotage de la fonction finance",
          "Supervision comptable et clôtures mensuelles",
          "Trésorerie, BFR et financements",
          "Contrôle interne et gestion des risques",
        ],
      },
      {
        num: "02",
        title: "Contrôle de gestion & pilotage de la performance",
        short: "Piloter par la donnée, décider avec clarté.",
        desc: "Des outils de pilotage fiables et des analyses orientées décision pour éclairer la direction et améliorer la rentabilité.",
        points: [
          "Budgets, forecasts et contrôle budgétaire",
          "Reporting, KPI et tableaux de bord",
          "Analyse des écarts, P&L et FP&A",
          "Marges, rentabilité et scénarios d'aide à la décision",
        ],
      },
      {
        num: "03",
        title: "Transformation Finance",
        short: "Réorganiser et fiabiliser la fonction finance.",
        desc: "Un diagnostic clair, une organisation cible et une conduite du changement maîtrisée pour transformer durablement la fonction.",
        points: [
          "Diagnostic et organisation cible",
          "Optimisation des processus et des outils",
          "Clarification des rôles et responsabilités",
          "Gouvernance et conduite du changement",
        ],
      },
      {
        num: "04",
        title: "Systèmes d'information",
        short: "Digitaliser et fiabiliser vos flux financiers.",
        desc: "Le bon outil, bien déployé : ERP, automatisation, fiabilisation des données et reporting décisionnel.",
        points: [
          "ERP et systèmes d'information finance",
          "Digitalisation et automatisation des flux",
          "Fiabilisation des données et data visualisation",
          "Cadrage et déploiement d'outils de reporting",
        ],
      },
      {
        num: "05",
        title: "Organisation & Performance RH",
        short: "Aligner les ressources sur la stratégie.",
        desc: "Piloter les effectifs, la masse salariale et les processus RH en cohérence avec les priorités de l'entreprise.",
        points: [
          "Pilotage des effectifs et de la masse salariale",
          "KPI RH, processus RH et paie",
          "Organisation des équipes et des ressources",
          "Alignement avec les priorités stratégiques",
        ],
      },
      {
        num: "06",
        title: "Management de transition",
        short: "Une prise en charge immédiate et sécurisée.",
        desc: "Une relève rapide de la fonction finance pour assurer la continuité, conduire la transformation et transmettre.",
        points: [
          "Prise en charge rapide de la fonction finance",
          "Continuité managériale et remplacement temporaire",
          "Pilotage de transformation",
          "Transmission et montée en compétence des équipes",
        ],
      },
    ],
    manifesto: {
      eyebrow: "Une approche orientée résultats",
      title: "Décider, sécuriser, optimiser, transformer.",
      chapters: [
        { num: "01", title: "Diagnostic ciblé", body: "Comprendre le contexte, identifier les enjeux réels et les leviers de valeur prioritaires." },
        { num: "02", title: "Priorisation", body: "Concentrer les efforts sur ce qui compte : décisions, risques et gains rapides." },
        { num: "03", title: "Mise en œuvre", body: "Traduire les priorités en actions mesurables et en résultats concrets." },
        { num: "04", title: "Transmission", body: "Sécuriser la continuité et faire monter les équipes en compétence." },
      ],
    },
    founder: {
      eyebrow: "La fondatrice",
      name: "Emna Mezghani",
      role: "Direction financière externalisée · Management de transition",
      subrole: "Contrôle de gestion et pilotage de la performance",
      body: "Une expertise en direction financière et contrôle de gestion, acquise dans des environnements exigeants, multisectoriels et en transformation. Vision stratégique et exigence opérationnelle au service des dirigeants.",
      quote: "Vision stratégique. Exigence opérationnelle.",
      figures: [
        { value: "9", label: "Ans d'expérience" },
        { value: "200 M€", label: "Périmètre budgétaire" },
        { value: "CODIR & COMEX", label: "Gouvernance" },
      ],
      referencesTitle: "Références",
      references: ["Thomson Broadcast", "Faurecia", "Grant Thornton", "TotalEnergies", "Riot Games — Arcane"],
    },
    ctaBand: {
      note: "",
      title: "Échangeons sur vos enjeux financiers et vos priorités de transformation.",
      body: "Temps partagé, transition ou mission ciblée : construisons le format d'accompagnement adapté à votre situation.",
      cta: "Prendre rendez-vous",
    },
    aboutPage: {
      eyebrow: "Le cabinet",
      title: "Une expérience de terrain au service des dirigeants.",
      lead: "Une expertise en direction financière et contrôle de gestion, acquise dans des environnements exigeants, multisectoriels et en transformation.",
      valuesTitle: "Modalités d'intervention",
      values: [
        { title: "Temps partagé", body: "Une direction financière externalisée, présente selon le rythme et les besoins de l'entreprise." },
        { title: "Transition / Remplacement", body: "Une prise de relais immédiate pour sécuriser la continuité et conduire le changement." },
        { title: "Mission ciblée", body: "Un enjeu précis, des livrables définis et un calendrier maîtrisé." },
      ],
    },
    servicesPage: {
      eyebrow: "Domaines d'intervention",
      title: "Une offre modulable, de l'enjeu ciblé à la prise en charge complète.",
      lead: "Six expertises pour structurer, piloter et transformer la fonction finance, selon vos priorités.",
      approachTitle: "Une approche orientée résultats",
      approachLead: "Une méthode claire, du diagnostic à la transmission.",
      verbs: ["Décider", "Sécuriser", "Optimiser", "Transformer"],
      steps: ["Diagnostic ciblé", "Priorisation", "Mise en œuvre", "Transmission"],
    },
    contactPage: {
      eyebrow: "Parlons de votre projet",
      title: "Contact & rendez-vous",
      lead: "Échangeons sur vos enjeux financiers et vos priorités de transformation.",
      tabMessage: "Envoyer un message",
      tabBook: "Prendre rendez-vous",
      form: {
        name: "Nom complet", email: "Email", company: "Société", subject: "Sujet", message: "Votre message",
        phone: "Téléphone", service: "Domaine d'intervention", date: "Date souhaitée", time: "Créneau horaire", notes: "Précisions (optionnel)",
        send: "Envoyer le message", book: "Confirmer la demande", sending: "Envoi en cours...",
        selectService: "Sélectionner un domaine", selectTime: "Choisir un créneau",
      },
      info: { phone: "Téléphone", email: "Email", web: "Localisation", location: "Disponibilité" },
      successMsg: "Message envoyé — nous vous répondrons rapidement.",
      successBook: "Demande de rendez-vous envoyée — nous vous confirmerons le créneau.",
      errorMsg: "Une erreur est survenue. Merci de réessayer.",
    },
    footer: {
      tagline: "Transformer la performance financière en avantage stratégique.",
      nav: "Navigation", contactTitle: "Contact", rights: "Tous droits réservés.",
    },
  },
  en: {
    nav: { home: "Home", services: "Expertise", about: "Firm", contact: "Contact", book: "Book a call" },
    hero: {
      eyebrow: "Financial advisory for executives",
      titleLines: ["A finance function", "that clarifies, secures"],
      titleAccent: "and accelerates performance.",
      lead: "EMG Performance 360 steps in when leadership needs visibility, control and an immediate capacity to execute.",
      cta: "Discuss your challenges",
      ctaSecondary: "Our areas of expertise",
    },
    pillars: {
      eyebrow: "What we deliver",
      items: [
        { num: "01", title: "Visibility", body: "Reliable, readable and decision-oriented information." },
        { num: "02", title: "Control", body: "Cash, margins, costs and risks under control." },
        { num: "03", title: "Execution", body: "Priorities quickly turned into measurable action." },
      ],
    },
    marquee: ["Decide", "Secure", "Optimize", "Transform", "Visibility", "Control", "Execution"],
    intro: {
      eyebrow: "01 — The firm",
      title: "Financial advisory, closest to your decisions.",
      body: "A firm specialized in financial management, management control and performance steering, EMG Performance 360 structures the finance function, secures the business and turns data into decision levers — from a targeted issue to full ownership of the function.",
      stats: [
        { value: "9", label: "Years of experience" },
        { value: "€200M", label: "Budget scope steered" },
        { value: "CODIR & COMEX", label: "Governance" },
      ],
    },
    servicesPreview: {
      eyebrow: "02 — Areas of intervention",
      title: "Six areas of expertise to structure, steer and transform the finance function.",
      cta: "Explore the expertise",
    },
    services: [
      {
        num: "01",
        title: "Outsourced Financial Management",
        short: "Steering the finance function, at your company's pace.",
        desc: "An available, operational finance leadership to structure, supervise and secure the entire finance function.",
        points: [
          "Structuring and steering the finance function",
          "Accounting supervision and monthly closings",
          "Cash, working capital and financing",
          "Internal control and risk management",
        ],
      },
      {
        num: "02",
        title: "Management Control & Performance Steering",
        short: "Steer by data, decide with clarity.",
        desc: "Reliable steering tools and decision-oriented analysis to inform leadership and improve profitability.",
        points: [
          "Budgets, forecasts and budget control",
          "Reporting, KPIs and dashboards",
          "Variance analysis, P&L and FP&A",
          "Margins, profitability and decision scenarios",
        ],
      },
      {
        num: "03",
        title: "Finance Transformation",
        short: "Reorganize and strengthen the finance function.",
        desc: "A clear diagnosis, a target organization and controlled change management to transform the function for good.",
        points: [
          "Diagnosis and target organization",
          "Process and tooling optimization",
          "Clarified roles and responsibilities",
          "Governance and change management",
        ],
      },
      {
        num: "04",
        title: "Information Systems",
        short: "Digitalize and strengthen your financial flows.",
        desc: "The right tool, well deployed: ERP, automation, data reliability and decision reporting.",
        points: [
          "ERP and finance information systems",
          "Digitalization and flow automation",
          "Data reliability and visualization",
          "Reporting tools scoping and rollout",
        ],
      },
      {
        num: "05",
        title: "Organization & HR Performance",
        short: "Align resources with strategy.",
        desc: "Steer headcount, payroll and HR processes in line with the company's priorities.",
        points: [
          "Headcount and payroll steering",
          "HR KPIs, HR processes and payroll",
          "Team and resource organization",
          "Alignment with strategic priorities",
        ],
      },
      {
        num: "06",
        title: "Interim Management",
        short: "Immediate, secured ownership of the function.",
        desc: "A fast handover of the finance function to ensure continuity, drive transformation and transfer knowledge.",
        points: [
          "Fast ownership of the finance function",
          "Managerial continuity and temporary replacement",
          "Transformation steering",
          "Knowledge transfer and team upskilling",
        ],
      },
    ],
    manifesto: {
      eyebrow: "A results-driven approach",
      title: "Decide, secure, optimize, transform.",
      chapters: [
        { num: "01", title: "Targeted diagnosis", body: "Understand the context, identify the real issues and the priority value levers." },
        { num: "02", title: "Prioritization", body: "Focus effort on what matters: decisions, risks and quick wins." },
        { num: "03", title: "Implementation", body: "Turn priorities into measurable actions and concrete results." },
        { num: "04", title: "Handover", body: "Secure continuity and upskill the teams." },
      ],
    },
    founder: {
      eyebrow: "The founder",
      name: "Emna Mezghani",
      role: "Outsourced Financial Management · Interim Management",
      subrole: "Management control and performance steering",
      body: "Expertise in financial management and management control, gained in demanding, multi-sector and transforming environments. Strategic vision and operational rigor, in service of executives.",
      quote: "Strategic vision. Operational rigor.",
      figures: [
        { value: "9", label: "Years of experience" },
        { value: "€200M", label: "Budget scope" },
        { value: "CODIR & COMEX", label: "Governance" },
      ],
      referencesTitle: "References",
      references: ["Thomson Broadcast", "Faurecia", "Grant Thornton", "TotalEnergies", "Riot Games — Arcane"],
    },
    ctaBand: {
      note: "",
      title: "Let's discuss your financial challenges and transformation priorities.",
      body: "Part-time, transition or targeted mission: let's build the support format that fits your situation.",
      cta: "Book a meeting",
    },
    aboutPage: {
      eyebrow: "The firm",
      title: "Field experience in service of executives.",
      lead: "Expertise in financial management and management control, gained in demanding, multi-sector and transforming environments.",
      valuesTitle: "Modes of engagement",
      values: [
        { title: "Part-time", body: "An outsourced finance leadership, present at the pace and needs of the company." },
        { title: "Transition / Replacement", body: "An immediate handover to secure continuity and drive change." },
        { title: "Targeted mission", body: "A precise issue, defined deliverables and a controlled timeline." },
      ],
    },
    servicesPage: {
      eyebrow: "Areas of intervention",
      title: "A modular offer, from a targeted issue to full ownership.",
      lead: "Six areas of expertise to structure, steer and transform the finance function, according to your priorities.",
      approachTitle: "A results-driven approach",
      approachLead: "A clear method, from diagnosis to handover.",
      verbs: ["Decide", "Secure", "Optimize", "Transform"],
      steps: ["Targeted diagnosis", "Prioritization", "Implementation", "Handover"],
    },
    contactPage: {
      eyebrow: "Let's talk about your project",
      title: "Contact & booking",
      lead: "Let's discuss your financial challenges and transformation priorities.",
      tabMessage: "Send a message",
      tabBook: "Book a meeting",
      form: {
        name: "Full name", email: "Email", company: "Company", subject: "Subject", message: "Your message",
        phone: "Phone", service: "Area of intervention", date: "Preferred date", time: "Time slot", notes: "Details (optional)",
        send: "Send message", book: "Confirm request", sending: "Sending...",
        selectService: "Select an area", selectTime: "Choose a slot",
      },
      info: { phone: "Phone", email: "Email", web: "Location", location: "Availability" },
      successMsg: "Message sent — we'll get back to you shortly.",
      successBook: "Booking request sent — we'll confirm your slot.",
      errorMsg: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "Turning financial performance into strategic advantage.",
      nav: "Navigation", contactTitle: "Contact", rights: "All rights reserved.",
    },
  },
};

export const CONTACT = {
  phone: "07 77 37 34 06",
  email: "emna.mezghani@outlook.com",
  web: "Paris — Île-de-France",
};
